<div class="container my-4">
	<div class="d-flex justify-content-between align-items-center mb-3">
		<h4>Stawki wynagrodzenia</h4>
		<button (click)="addRate()" [disabled]="isLoading() || !touristGuideId()" color="primary" mat-raised-button>
			<i class="fas fa-plus"></i> Dodaj stawkę
		</button>
	</div>

	@if (isLoading()) {
		<div class="text-center my-5">
			<mat-spinner diameter="50" style="margin: 0 auto"></mat-spinner>
			<p class="mt-3">Ładowanie stawek...</p>
		</div>
	}

	@if (error() && !isLoading()) {
		<div class="alert alert-danger" role="alert">
			<i class="fas fa-exclamation-triangle"></i> {{ error() }}
			<button (click)="loadRates()" class="btn btn-sm btn-outline-danger ms-3">
				<i class="fas fa-redo"></i> Spróbuj ponownie
			</button>
		</div>
	}

	@if (!isLoading() && !error()) {
		<mat-table #dataTable [dataSource]="matData" class="mat-elevation-z2" matSort>
			<ng-container matColumnDef="position">
				<mat-header-cell *matHeaderCellDef> LP</mat-header-cell>
				<mat-cell *matCellDef="let element; let i = index">{{ i + 1 }}</mat-cell>
			</ng-container>

			<ng-container matColumnDef="dateFrom">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Data od</mat-header-cell>
				<mat-cell *matCellDef="let element">{{ element.dateFrom | formatDateTime }}</mat-cell>
			</ng-container>

			<ng-container matColumnDef="dateTo">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Data do</mat-header-cell>
				<mat-cell *matCellDef="let element">{{ element.dateTo | formatDateTime }}</mat-cell>
			</ng-container>

			<ng-container matColumnDef="rate">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Stawka (PLN)</mat-header-cell>
				<mat-cell *matCellDef="let element">{{ element.rate | price }} PLN</mat-cell>
			</ng-container>

			<ng-container matColumnDef="comments">
				<mat-header-cell *matHeaderCellDef> Uwagi</mat-header-cell>
				<mat-cell *matCellDef="let element">{{ element.comments }}</mat-cell>
			</ng-container>

			<ng-container matColumnDef="actions">
				<mat-header-cell *matHeaderCellDef> Akcje</mat-header-cell>
				<mat-cell *matCellDef="let element">
					<button (click)="editRate(element)" class="me-2" color="primary" mat-raised-button>
						<i class="fas fa-edit"></i> Edytuj
					</button>
					<button (click)="deleteRate(element)" color="warn" mat-raised-button>
						<i class="fas fa-trash"></i> Usuń
					</button>
				</mat-cell>
			</ng-container>

			<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
			<mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
		</mat-table>
	}

	@if (!isLoading() && !error() && rates().length === 0) {
		<div class="text-center my-5">
			<i class="fas fa-inbox fa-3x text-muted"></i>
			<p class="mt-3 text-muted">Brak stawek wynagrodzenia. Dodaj pierwszą stawkę.</p>
		</div>
	}
</div>
